/**
 * Get localized name from location data based on current language
 * @param {Object} locationData - Location data object with name_kz, name_en, name_ru, etc.
 * @param {string} lang - Language code (kz, en, ru, zh, ky, uz)
 * @returns {string} Localized name
 */
export function getLocalizedName(locationData, lang = null) {
    if (!locationData) return '';
    
    // Get language from localStorage if not provided
    if (!lang) {
        lang = localStorage.getItem('language') || 'ru';
    }
    
    // Map language codes
    const langMap = {
        'kz': 'name_kz',
        'en': 'name_en',
        'ru': 'name_ru',
        'zh': 'name_zh',
        'cn': 'name_zh', // Chinese
        'ky': 'name_ky',
        'uz': 'name_uz'
    };
    
    const nameKey = langMap[lang] || 'name_ru';
    return locationData[nameKey] || locationData.name_ru || locationData.name_en || locationData.name_kz || '';
}

/**
 * Find country by name (fuzzy matching)
 * @param {Array} countries - Array of country objects
 * @param {string} countryName - Country name to search for
 * @returns {Object|null} Matching country object or null
 */
export function findCountryByName(countries, countryName) {
    if (!countries || !countryName) return null;
    
    const normalizedName = countryName.toLowerCase().trim();
    
    return countries.find(country => {
        const nameKz = (country.name_kz || '').toLowerCase();
        const nameEn = (country.name_en || '').toLowerCase();
        const nameRu = (country.name_ru || '').toLowerCase();
        
        return nameKz.includes(normalizedName) || 
               nameEn.includes(normalizedName) || 
               nameRu.includes(normalizedName) ||
               normalizedName.includes(nameKz) ||
               normalizedName.includes(nameEn) ||
               normalizedName.includes(nameRu);
    }) || null;
}

/**
 * Find region by name (fuzzy matching)
 * @param {Array} regions - Array of region objects
 * @param {string} regionName - Region name to search for
 * @returns {Object|null} Matching region object or null
 */
export function findRegionByName(regions, regionName) {
    if (!regions || !regionName) return null;
    
    const normalizedName = regionName.toLowerCase().trim();
    
    return regions.find(region => {
        const nameKz = (region.name_kz || '').toLowerCase();
        const nameEn = (region.name_en || '').toLowerCase();
        const nameRu = (region.name_ru || '').toLowerCase();
        
        return nameKz.includes(normalizedName) || 
               nameEn.includes(normalizedName) || 
               nameRu.includes(normalizedName) ||
               normalizedName.includes(nameKz) ||
               normalizedName.includes(nameEn) ||
               normalizedName.includes(nameRu);
    }) || null;
}

/**
 * Find district by name (fuzzy matching)
 * @param {Array} districts - Array of district objects
 * @param {string} districtName - District name to search for
 * @returns {Object|null} Matching district object or null
 */
export function findDistrictByName(districts, districtName) {
    if (!districts || !districtName) return null;
    
    const normalizedName = districtName.toLowerCase().trim();
    
    return districts.find(district => {
        const nameKz = (district.name_kz || '').toLowerCase();
        const nameEn = (district.name_en || '').toLowerCase();
        const nameRu = (district.name_ru || '').toLowerCase();
        
        return nameKz.includes(normalizedName) || 
               nameEn.includes(normalizedName) || 
               nameRu.includes(normalizedName) ||
               normalizedName.includes(nameKz) ||
               normalizedName.includes(nameEn) ||
               normalizedName.includes(nameRu);
    }) || null;
}

